class CurrentFeatureController {
    constructor($window, $http, toastr) {
        this.$onInit = () => {
            this.appFlags = {};
            this.setAppFlags();
        };
        this.setAppFlags = () => {
            this.http.get('scripts/app/feature-set.json').then((response) => {
                let appFlags = response.data;
                this.appFlags = this.createAppFlags(appFlags);
            });
        };
        this.createAppFlags = (appOptions) => {
            let roleOptions = {};
            // Set true for included
            angular.forEach(appOptions.include, (value) => {
                let prop = {};
                prop[value] = true;
                angular.extend(roleOptions, prop);
            });
            // Set false for excluded
            angular.forEach(appOptions.exclude, (value) => {
                let prop = {};
                prop[value] = false;
                angular.extend(roleOptions, prop);
            });
            return roleOptions;
        };
        this.window = $window;
        this.http = $http;
        this.toastr = toastr;
    }
}
angular.module('app').component('currentFeatures', {
    templateUrl: 'Scripts/App/partials/Features/current-features.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: CurrentFeatureController
});
